module.exports = __webpack_public_path__ + "static/media/SANDDOLAR.ab65baa5.pdf";